<template>
  <v-app>
    <!--編輯-->
    <v-dialog v-model="isVisible"
              no-click-animation
              max-width="80%">
      <v-card>
        <v-card-title>{{getTitle}}</v-card-title>
        <v-card-text>
        <v-layout row wrap >
            <v-flex xs1 md1 >
                <v-btn color="primary" dark text @click="createGroup()" >新增ECU群組</v-btn>
            </v-flex>
            </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
                <table-view :columnKeys="columnKeys"
                    :items="items"
                    :loading="loading"
                    :total-items="totalItems"
                    @cellEvent="cellEvent"
                    @handleLoadData="reset">
                </table-view>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="primary" dark text @click="confirmEvent">確定</v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="ecuDialog.visible"
              no-click-animation
              max-width="80%">
      <v-card>
        <v-card-title>{{ecuDialog.title}}</v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 d-flex class="justify-center">
                <v-text-field :label="`ECU群組名稱`" v-model="ecuDialog.name"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 d-flex class="justify-center">
                <!-- <v-color-picker v-model="ecuDialog.color"></v-color-picker> -->
                <chrome-picker :value="ecuDialog.color" @input="updateFromPicker"/>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" dark text @click="ecuDialog.cancel">取消</v-btn>
            <v-btn class="primary" dark text @click="ecuDialog.confirm">確定</v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
    <alert-view :visible="messageDialog.visible"
                  :title="messageDialog.title"
                  :content="messageDialog.text"
                  @confirmEvent="messageDialog.confirm"></alert-view>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AlertView from '@/components/AlertView';
import TableView from '@/components/TableView';
import { Chrome } from "vue-color";

const bankCodeList = require('../assets/bank_data.json');

export default {
  name: 'EcuManageDialog',
  components: {
    AlertView, TableView, "chrome-picker": Chrome
  },
  props: {
    visible: Boolean,
  },
  data() {
    return {
      loading: false,
      isVisible: false,
      pageIndex: 1,
      limit: 5,
      totalItems: 0,
      items: [],
      messageDialog: {
        title: "",
        text: "",
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      ecuDialog:{
        title: "",
        visible: false,
        name:"",
        color: "",
        confirm: () => {},
        cancel: () => {},
      },

    };
  },
  async created() {
    this.loadData(this.pageIndex, this.limit);
    this.fetchAgentList().then(res=>{});
  },
  watch:{
    visible(value){
      this.isVisible = value;
    },
    isVisible(value) {
      if(!value) {
        this.confirmEvent()
      }
    }
  },
  computed:{
    ...mapGetters(['getUserInfo','getAgentList']),
    isAdmin() {
      return this.getUserInfo.authority === 'admin';
    },
    columnKeys() {
      return [
        { value: "edit", text: "編輯", sortable: false, required: false , color:'primary', isEvent: true},
        { value: "name", text: "名稱", sortable: true, required: false },
        { value: "color", text: "顏色", sortable: true, required: false ,hidden:true},
        { value: "delete", text: "刪除", sortable: false, required: false , isEvent: true}]
    },
    getTitle () {
      return  `ECU群組列表`
    }
  },
  methods: {
    ...mapActions(['fetchAgentList','ecuList','ecuCreate','ecuUpdate', 'ecuDelete']),

    async loadData(pageIndex, limit) {
      const results = await this.ecuList()
      this.items = results.data.data
    },
    updateFromPicker(color){
      console.log(color)
      this.ecuDialog.color = color.hex;
    },
    cellEvent(props) { // cell 按鈕事件 (用Key判斷是點選哪一個
      console.log(`cellEvent ${JSON.stringify(props)}`)
      if (props.key === 'edit'){
        this.showEditAction(props.item)
      }
      if (props.key === 'delete'){
        this.deleteAlertView(props.item)
      }
    },
    confirmEvent(){
      this.$emit('confirmEvent');
    },
    showMessageDialog(title, text, visible, confirmEvent, cancelEvent) {
      this.messageDialog.title = title;
      this.messageDialog.text = text;
      this.messageDialog.visible = visible;
      const self = this;
      this.messageDialog.confirm = () => {
        self.messageDialog.visible = false;
        if (confirmEvent) {
          confirmEvent();
        }
      };

      this.messageDialog.cancel = () => {
        self.messageDialog.visible = false;
        if (cancelEvent) {
          cancelEvent();
        }
      };
    },
    createGroup() {
      const info = {
        name:'',
        color:''}
      this.groupEditDialog(info,
        async () => {
          const dataInfo = {
            "name": this.ecuDialog.name,
            "color": this.ecuDialog.color
          }
          console.log(`createGroup == ${JSON.stringify(dataInfo)}`)
          const results = await this.ecuCreate(dataInfo)
          console.log(`${JSON.stringify(results)}`)

          let message = `新增成功！`
          this.showMessageDialog("提示",message,true,
          () => {
            this.messageDialog.visible = false
            this.loadData(this.pageIndex, this.limit);
          }, () => {
            this.messageDialog.visible = false
          })
        })
    },
    showEditAction(info){
      this.groupEditDialog(info,
        async () => {
          const dataInfo = {
            "groupId": info.groupId,
            "name": this.ecuDialog.name,
            "color": this.ecuDialog.color
          }
          console.log(`createGroup == ${JSON.stringify(dataInfo)}`)
          const results = await this.ecuUpdate(dataInfo)
          console.log(`${JSON.stringify(results)}`)

          let message = `修改成功！`
          this.showMessageDialog("提示",message,true,
          () => {
            this.messageDialog.visible = false
            this.loadData(this.pageIndex, this.limit);
          }, () => {
            this.messageDialog.visible = false
          })
        })
    },
    groupEditDialog(info, confirmEvent) {
      this.ecuDialog.visible = true
      this.ecuDialog.name = info.name
      this.ecuDialog.color = info.color
      const self = this;
      this.ecuDialog.confirm = () => {
        self.ecuDialog.visible = false;
        if (confirmEvent) {
          confirmEvent();
        }
      };

      this.ecuDialog.cancel = () => {
        self.ecuDialog.visible = false;
      };
    },
    async deleteAlertView(info){
      this.messageDialog.showCancelButton = true
        let message = `是否刪除此商品  ？`
        this.showMessageDialog("提示",message,true,
        () => {
          this.messageDialog.showCancelButton = false
          this.messageDialog.visible = false
          this.deleteEvent(info)
        }, () => {
          this.messageDialog.showCancelButton = false
          this.messageDialog.visible = false
        })
    },
    async deleteEvent(info) {
      let results = await this.ecuDelete({
        "groupId": info.groupId
      })
      this.showMessageDialog("提示",results.data.message,true,
        () => {
          this.messageDialog.visible = false
        })
      await this.loadData(this.pageIndex, this.limit);
    },
    reset(){
      this.loadData(this.pageIndex, this.limit);
    },
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/EcuManageDialog.vue